module.exports = __webpack_public_path__ + "static/img/son3_active.60880714.png";